"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TooltipTitle;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
/**
 * Render the title of the tooltip.
 *
 * @param {Object} props Component properties.
 * @returns {ReactElement} Div containing title.
 * @private
 */
function TooltipTitle(_ref) {
  let {
    children,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, children);
}

/**
 * Property types definition.
 *
 * @enum {Object} propTypes
 * @private
 */
TooltipTitle.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string
};